/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PaymentStatus.css';
import { connect } from 'react-redux'
import GrayPanel from '../../components/GrayPanel';
import SummaryMaterialsTable from '../../components/SummaryMaterialsTable';
import Link from '../../components/Link';
import cx from 'classnames';
import Select from 'react-select';
import { fetchStatus, fetchPZGiKClaim } from '../../lib/utils';
import _ from 'lodash';
import history from '../../core/history';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import waiting from './waiting-wheel-300x300.gif';
const isBrowser = typeof window !== 'undefined' && window !== null;
import fetch from '../../core/fetch';

const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px'
}

const calculatingShippingForms = [
  'Wysyłka pod wskazany adres',
  'Wysyłka pod wskazany adres - własny nośnik',
];

class PaymentStatus extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    jobID: React.PropTypes.string,
    claim: React.PropTypes.object,

  };

  state = {
    toPay: 0.00,
    docs: [],
    paymentStatus: this.props.claim.paymentStatus,
    isMounted: false,
    bankAccount: this.props.bankAccounts[0],
  }

  componentDidMount = () => {
    fetch(`${process.env.API_URL}/eservice/${this.props.claim.teryt}/${this.props.claim.shortName}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp
        })
      })
    this.setState({ isMounted: true });
    this.getPZGiKClaim()
  }

  getPZGiKClaim() {
    const pzgikList = ['UdostepnienieMaterialow', 'UdostepnienieMaterialowPublicznych'];
    if (!pzgikList.includes(this.props.claim.shortName)) return;
    fetchPZGiKClaim(this.props.claim.id)
    .then(resp => {
      this.setState({pzgik: resp})
    })
  }

  getPaymentStatus = paymentMethod => {
    // fetchStatus
    if (!this.state.disablePayment && paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED') {
      setTimeout(() => {
        fetchStatus(this.props.claim.jobId)
          .then(r => {
            if (r.status == 'STARTED') {
              this.getPaymentStatus(paymentMethod);
            } else {
              // window.href = `${window.location.host}/paymentStatus/${this.props.claim.jobId}`
              this.setState({ paymentStatus: r.status });
            }
          })
      }, 3000);
    }
  }

  getRequestSubject = () => {
    let requestSubject = ''
    this.state.pzgik.przedmiotWniosku.split(",").forEach((elem,index) => {
      if((index+1)%2 !== 0){
        requestSubject += (index*1/2+1)+ ". " + elem
      } else { 
        requestSubject+=","+elem+" "
      }
    })
    return requestSubject
  }

  getSummaryTextPzgik = () => {
    const shippingForm = this.state.pzgik.pzgik_claim_details[0].formaPrzekaz;
    const status = this.state.pzgik.status;
    const dataFormat = this.state.pzgik.pzgik_claim_details[0].formaMat;
    let text = '';
    if (!this.isPayablePurposePzgik()){
      text = `Wniosek zostanie zrealizowany po weryfikacji uprawnień do udostępnienia materiałów geodezyjnych nieodpłatnie w postaci elektronicznej przez Marszałka Województwa.
      Szczegóły realizacji wniosku będą przesyłane na wskazany we wniosku adres mailowy lub przekazywane telefonicznie na numer podany we wniosku.
      `;
    } else if (calculatingShippingForms.includes(shippingForm) && status === 'obliczanie opłaty za wysyłkę' && this.state.paymentStatus === 'waiting') {
      // 5. pł. online x wektor/raster x poczta - wlasny nosnik - PRZED ZAPLACENIEM
      // 6. pł. online x wektor/raster x poczta - PRZED ZAPLACENIEM
      // 8 pł. online x drukowana x poczta - PRZED ZAPLACENIEM
      text = `Wniosek zostanie zrealizowany po dokonaniu płatności. Niebawem zostaniesz poinformowany o wielkości doliczonego kosztu wysyłki pocztowej.
      Szczegóły realizacji wniosku będą przesyłane na wskazany we wniosku adres mailowy lub przekazywane telefonicznie na numer podany we wniosku.
      `;
    } else if (calculatingShippingForms.includes(shippingForm) && status === 'opłacono, przygotowano' && this.state.paymentStatus === 'SUCCESS') {
      // 5. pł. online x wektor/raster x poczta - wlasny nosnik - Po ZAPLACENIU
      // 6. pł. online x wektor/raster x poczta - PRZED ZAPLACENIEM
      text = `Wniosek został opłacony. Szczegóły realizacji wniosku będą przesyłane na wskazany we wniosku adres mailowy
       lub przekazywane telefonicznie na numer podany we wniosku.`;
    } else if (calculatingShippingForms.includes(shippingForm) && status === 'opłacono, do przygotowania' && this.state.paymentStatus === 'SUCCESS') {
      // 8 pł. online x drukowana x poczta - Po ZAPLACENIU
      text = `Wniosek został opłacony. Szczegóły realizacji wniosku będą przesyłane na wskazany we wniosku adres mailowy
       lub przekazywane telefonicznie na numer podany we wniosku.
      `;
    } else if (this.state.paymentStatus === 'SUCCESS') {
      // Po ZAPLACENIU
      text = `Wniosek został opłacony. Szczegóły realizacji wniosku będą przesyłane na wskazany we wniosku adres mailowy
       lub przekazywane telefonicznie na numer podany we wniosku.
      `;
    } else {
      text = `Wniosek zostanie zrealizowany po dokonaniu płatności. Upewnij się czy dokonałeś wszystkich niezbędnych płatności.
      Szczegóły realizacji wniosku będą przesyłane na wskazany we wniosku adres mailowy lub przekazywane telefonicznie na numer podany we wniosku.
      `;
    }
    return (
      <div className="row">
        <h5 style={{ textAlign: 'justify' }}>
          <br />
          {text}
          {['Udostępnienie na serwerze FTP WODGiK', 'Wysyłka na wskazany adres e-mail'].includes(shippingForm) && this.state.paymentStatus === 'SUCCESS' ? <p><br />Właśnie przygotowujemy Twoje mapy, już niedługo otrzymasz wiadomość e-mail z zamówionym materiałem.</p> : null }
          Szczegóły zamówienia znajdziesz w <a href={`/panel/${this.props.user.username}/mojedokumenty`}>Panelu Klienta</a>.
        </h5>
      </div>
    );
  }

  checkPaymentButton = () => {
    let show = true;
    let shippingForm = '';
    let status = '';
    if (this.state.pzgik) {
      shippingForm = this.state.pzgik.pzgik_claim_details[0].formaPrzekaz;
      status = this.state.pzgik.status;
    }

    if (calculatingShippingForms.includes(shippingForm) && status === 'obliczanie opłaty za wysyłkę') {
      // 5. pł. online x wektor/raster x poczta - wlasny nosnik
      show = false;
    }

    if (this.state.pzgik && !this.isPayablePurposePzgik()) {
      show = false;
    }

    return show;
  }

  isPayablePurposePzgik = () => {
    const purpose = this.state.pzgik.celPobrMat; 
    const payablePurposes = ["dla dowolnych potrzeb", "dla potrzeb własnych niezwiązanych z działalnością gospodarczą, bez prawa publikacji w sieci Internet"]
    return payablePurposes.includes(purpose)
  }

  render() {
    const paymentMethod = _.find(this.props.paymentMethods, v => v.id == this.props.claim.paymentMethod);
    if (!this.state.disablePayment && paymentMethod) {
      this.getPaymentStatus(paymentMethod);
    }
    const failures = this.props.claim.failures;
    const hasJobFailure = failures.reduce((prev, current) => current.failureType === "JobFailure" ? current : null, null);
    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };
    const claim = this.props.claim;
    const service = this.props.eservices[claim.shortName];

    let sum_cost = claim.documents.reduce((prev, next) => prev += next.cost, 0.00).toFixed(2);

    if (this.state.pzgik) {
      const carrierFee = this.state.pzgik.WysOplatyNosnik || 0.00;
      const feeAmount = this.state.pzgik.wysokoscOplaty || 0.00;
      const deliveryAmount = this.state.pzgik.wysOplatyPrzesylka || 0.00;
      sum_cost = (carrierFee + feeAmount + deliveryAmount).toFixed(2);
    }

    // if (claim.shortName == "invest_contact") {
    //   return (<h1>OK</h1>);
    // }
    const requestSubject = this.state.pzgik && this.getRequestSubject()
    const showPayButon = this.checkPaymentButton();
    
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.state.isMounted ?
            <GrayPanel titleStyle={this.state.pzgik && {textAlign: 'center', 'fontWeight':'bold'}} title={this.state.paymentStatus === 'waiting' && claim.shortName !== 'UdostepnienieMaterialowPublicznych' ? "Płatność" : "Podsumowanie"}>
              <div className="row" style={rowStyle}>
                <div className={leftCol} />
                {this.state.pzgik ? 
                  <h2 className={this.state.pzgik && s.sectionTitle}>Wniosek</h2> : <div className={labelCol}>
                    <label style={labelStyle}>Nazwa usługi:</label>
                  </div>
                }
                <div className={this.state.pzgik ? s.sectionBody : inputCol}>
                  <p style={labelStyle}>{service.title}</p>
                </div>
                <div className={rightCol} />
              </div>

              <div className="row" style={rowStyle}>
                <div className={leftCol} />
                {claim.parcels.length > 0 ? (
                  <div>
                    <div className={labelCol}>
                      <label style={labelStyle}>Lista działek:</label>
                    </div>
                    <div className={inputCol}>
                      {claim.parcels.map((parcel, i) => <span key={i}>{`${parcel.parcel}; `}</span>)}
                    </div>
                  </div>
                ) : null}
                <div className={rightCol} />
              </div>
              {hasJobFailure ?
                <div>
                  <h5>{hasJobFailure.reasonDisplay}</h5>
                </div>
                :
                <div>
                  {
                    claim.documents.length && !this.state.pzgik  ?
                      [
                        (<hr />),
                        (
                          <h3>{(sum_cost > 0.) && paymentMethod && (this.state.paymentStatus !== "SUCCESS") ? "Opłata za dokumenty" : "Podgląd wzorów dokumentów"}</h3>
                        ),
                        (<table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Nazwa pliku</th>
                              <th style={{ textAlign: 'center' }}>
                                {sum_cost > 0. ?
                                  `Wysokość opłaty` : null
                                }
                              </th>
                              {paymentMethod && ((paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) ?
                                <th style={{ textAlign: 'center' }}>Akcje</th>
                                : null
                              }
                            </tr>
                          </thead>
                          <tbody>
                            {claim.documents.map((doc, i) =>
                              <tr key={i}>
                                <td>{doc.fileName}</td>
                                <td style={{ textAlign: 'center' }}>
                                  {sum_cost > 0. && `${doc.cost.toFixed(2)} PLN`}
                                </td>
                                {/* {!paymentMethod || (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) ?
                                  <td style={{ textAlign: 'right' }}>
                                    {claim.documents.length < 1 ?
                                      <a className="btn btn-warning pull-right" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`} style={buttonPayStyle}>Pobierz</a> :
                                      <a className="btn btn-warning pull-right" target="_blank" href={`${process.env.API_URL}/eservices/getEscDocument/${doc.id}`} style={buttonPayStyle}>Pobierz</a>
                                    }
                                  </td>
                                  : null} */}
                              </tr>,
                            )}
                          </tbody>
                        </table>),
                        (<hr />)
                      ] : null
                  }
                  
                  {this.state.pzgik && 
                    (<div  className="row">
                      <h2 className={s.sectionTitle}>{this.state.paymentStatus === 'waiting' && claim.shortName !== 'UdostepnienieMaterialowPublicznych' ? "Płatność" : "Podsumowanie złożonego wniosku"}</h2>
                      <p>
                        <b>{requestSubject}</b>
                      </p>
                      <SummaryMaterialsTable requestSubject={requestSubject} shortName={this.props.claim.shortName} pzgik={this.state.pzgik} userDevice={this.props.claim.userDevice} isPayable={this.isPayablePurposePzgik()}/>
                    </div>)
                  }

                  {claim.shortName == "invest_contact" || claim.shortName == "invest_contact_form" ? (
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Nazwa pliku</th>
                          <th style={{ textAlign: 'right' }}>Akcje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>List intencyjny inwestora</td>
                          <td style={{ textAlign: 'right' }}>
                            <a className="btn btn-warning pull-right" target="_blank" href={`${process.env.API_URL}/invest/getInvestDoc/${this.props.jobID}`} style={buttonPayStyle}>Pobierz</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>) : null
                  }

                  {sum_cost > 0. &&
                    (paymentMethod && ((this.state.disablePayment || (this.state.paymentStatus === "SUCCESS" && paymentMethod.fk_method == '3'))) ?
                      <div className="row">
                        <span className="pull-left">Status</span>
                        <span className="pull-right"><b>Opłacono</b></span>
                      </div>
                      : null)
                  }
                  {sum_cost > 0. && paymentMethod && paymentMethod.fk_method != '3' ?
                    <div className="row">
                      <br />
                      <span className="pull-left"><b>Numer rachunku: {this.state.bankAccount && this.state.bankAccount.name ? this.state.bankAccount.name : '-'}</b></span>
                      <span className="pull-right">{this.state.bankAccount.number}</span>
                    </div>
                    : null
                  }

                  <br />
                  {this.state.pzgik && this.getSummaryTextPzgik()}
                  <div className="row" style={rowStyle}>
                    <div className="row">
                      {(this.state.pzgik && !this.isPayablePurposePzgik()) &&
                        <div>
                          <a className="btn btn-warning pull-left" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wniosek</a>
                          <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/eservices/getJobDocs/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wszystko</a>
                        </div>
                      }
                      {sum_cost > 0.  &&
                        <a className="btn btn-warning pull-left" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wniosek</a>
                      }
                      {sum_cost > 0.  && (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) ?
                        <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/eservices/getJobDocs/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wszystko</a>
                        : null}

                      {paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'waiting' && showPayButon) ?
                        <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/eservices/jobPayment/${this.props.jobID}`} style={buttonPayStyle}>Zapłać</a>
                        : null}
                      {/* {paymentMethod && (paymentMethod.fk_method == '3' && (this.state.paymentStatus === 'waiting' || this.state.paymentStatus === 'FAILURE')) ?
                        <a className="btn btn-primary pull-right" href={`/eservices/eserviceSummary/${this.props.jobID}`} style={buttonPayStyle}>Wróć do wyboru formy płatności</a>
                        : null} */}
                      {paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED') ?
                        <b><span className="pull-right">Czekamy na odpowiedź z banku <img style={{ width: '48px', height: '48px' }} role="presentation" src={waiting} /></span></b>
                        : null}
                      {paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'FAILURE') ?
                        <span className="pull-right" style={{ color: 'red' }}>Nie udało się dokonać przelewu, prosimy zgłosić się do ekipy GIAP w celu weryfikacji zaistniałej sytuacji lub wrócić do wyboru formy płatności.</span>

                        : null}
                      {!showPayButon ?
                        <PowrotDoListyEuslug position="right" prefix={this.props.claim.prefix} />
                      : null}
                    </div>
                    {!this.state.pzgik && <div className="row">
                      <h5 style={{ textAlign: 'justify' }}>
                        <br />
                        {((sum_cost > 0.00 && paymentMethod && ((paymentMethod.fk_method != '3') || (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS'))) && (claim.shortName !== 'invest_contact_form' || claim.shortName !== 'invest_contact')) ?
                          'Twój wniosek został przekazany do Urzędu. Upewnij się czy dokonałeś opłaty za dokumenty. O dalszych krokach realizacji e-usługi będziesz informowany przez osobę realizującą Twoją sprawę.' :
                          null  
                        }
                        {(paymentMethod && paymentMethod.fk_method == '3' && this.state.paymentStatus !== 'SUCCESS') ?
                          'Twój wniosek zostanie przekazany do urzędu po dokonaniu płatności. ' :
                          null
                        }
                        {claim.shortName === 'invest_contact' || claim.shortName === 'invest_contact_form' ?
                          <p>List intencyjny trafił do urzędu. O dalszych krokach realizacji e-usługi będziesz informowany przez osobę realizującą Twoją sprawę.</p> : null
                        }
                        <br />
                        {(this.props.claim.isSigned && paymentMethod && paymentMethod.label === 'Płatność elektroniczna' && this.props.claim.paymentStatus === 'SUCCESS')
                          || (this.props.claim.isSigned && paymentMethod && paymentMethod.label !== 'Płatność elektroniczna') ?
                          <b>W sekcji podgląd wzorów dokumentów umieszczamy wzory przygotowanych dokumentów.
                      Oryginały dokumentów zostaną przekazane przez Urząd zgodnie z wybranym sposobem doręczenia</b>
                          : null}
                        <br /><br />
                        {!this.state.pzgik && "Dziękujemy za skorzystanie z e-usługi!"}
                    </h5>
                      {(sum_cost <= 0. && (claim.shortName != "invest_contact" && claim.shortName != "invest_contact_form")) ?
                        <a className="btn btn-warning pull-left" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wniosek</a> : null
                      }
                      <PowrotDoListyEuslug position="right" prefix={this.props.claim.prefix} />
                    </div> }
                  </div>
                </div>
              }
              {/* {this.props.user.username === "habibi07" ? <div>
              <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/eservices/getJobDocs/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wszystko</a>
              <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/service/requeue/${this.props.jobID}`} style={buttonPayStyle}>Uruchom ponownie</a>
              {claim.documents.map((doc, i) => <a className="btn btn-warning pull-left" key={i} target="_blank" href={`${process.env.API_URL}/eservices/getEscDocument/${doc.id}`} style={buttonPayStyle}>Pobierz</a>)}
            </div> : null } */}

            </GrayPanel>
            : <GrayPanel title="Podsumowanie" bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}><img role="presentation" src={waiting} /></GrayPanel>}
        </div>
      </div>
    );
  }
}

PaymentStatus.contextTypes = {
  fontSizeScale: React.PropTypes.number,
};


const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default withStyles(s)(connect(mapState)(PaymentStatus));



// WEBPACK FOOTER //
// src/routes/paymentStatus/PaymentStatus.js